
$(document).ready(function() {
  this.isMap = true;
  var main_col = $("#main-content-column, .alfred-graph-container"),
    col_width = main_col.width(),
    height = graphHeight;

  $('#resizable-graph-container').css({
    'width': col_width + 'px',
  });

  $('#resizable-graph-container').css({
    'width': col_width + 'px',
    'height': height + 'px'
  });

  $('#width').val(col_width).data('original-width', col_width);
  $('#height').val(height).data('original-height', height);
  setGraphSize(document.getElementById('main-content-column').offsetWidth,graphHeight);
});

function setGraphSize(graphWidth,graphHeight,oc){
  window.fredgraph.setGraphSize(graphWidth,graphHeight);
}

function updateMetaContent(jsonObject){

}
window.updateMetaContent =updateMetaContent;

function setDateChart(){

}
window.setDateChart =setDateChart;

function setNonDateChart(minDate, maxDate, currentDate, frequency){

}
window.setNonDateChart = setNonDateChart;

function initPieDatePicker(startDate, endDate, frequency){

}

function setDateInputs(jsonObject, cosd, coed) {

}
window.setDateInputs = setDateInputs;

function handleAfterSetExtremes(jsonObject, chartObject) {
  $('#input-coed').val(jsonObject.extremes.dataEndDate);
  
}
window.handleAfterSetExtremes = handleAfterSetExtremes;

function postToApi(jsonObject,endpoint,callback) {

}

function setMapChart() {
  this.isMap = true;
}
window.setMapChart= setMapChart;

function unsetMapChart() {
  this.isMap = false;
}
window.unsetMapChart = unsetMapChart;
